'use strict';

var React = require('react');
var CompositeIconBase = require('../common/CompositeIconBase');
var IconButtonCommon = React.createClass({
  render : function(){
    return (<CompositeIconBase
      {...this.props}
      borderVisible={false}
      alarmVisible={false}
      iconVisible={true}
      labelVisible={true}>
      {
        this.props.children
      }
    </CompositeIconBase>);
  }
});

module.exports = IconButtonCommon;


// WEBPACK FOOTER //
// ./src/views/Components/IconButtonCommon.jsx